/* unplugin-vue-components disabled */import { render } from "./Observed.vue?vue&type=template&id=f90ec55e"
import script from "./Observed.vue?vue&type=script&lang=js"
export * from "./Observed.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__